import { render, staticRenderFns } from "./FilterStars.vue?vue&type=template&id=549c0ae2&scoped=true"
import script from "./FilterStars.vue?vue&type=script&lang=js"
export * from "./FilterStars.vue?vue&type=script&lang=js"
import style0 from "./FilterStars.vue?vue&type=style&index=0&id=549c0ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549c0ae2",
  null
  
)

export default component.exports